export const TableNames = {
  EMAIL_SETTING: "email-settings",
  NOTIFY_GROUPS: "groups-to-notify",
  LINE_CONFIG: "line-config",
  TELEGRAM_CONFIG: "telegram-config",
  CONFIG_TARGET_GROUPS_OPT: "config-target-groups-opt",
  CONFIG_FILTER_OPT: "config-filter-opt",
  CONFIG_WARNING_OPT: "config-warning-opt",
};